import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Wallet = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 16.172V7C26 5.346 24.654 4 23 4H9C6.243 4 4 6.243 4 9V23C4 25.757 6.243 28 9 28H23C24.654 28 26 26.654 26 25V23.828C27.164 23.415 28 22.304 28 21V19C28 17.696 27.164 16.585 26 16.172ZM9 6H23C23.551 6 24 6.449 24 7V8H9C8.448 8 8 8.448 8 9C8 9.552 8.448 10 9 10H24V12H9C7.346 12 6 10.654 6 9C6 7.346 7.346 6 9 6ZM24 25C24 25.551 23.551 26 23 26H9C7.346 26 6 24.654 6 23V12.997C6.836 13.626 7.875 14 9 14H24V16H22C19.794 16 18 17.794 18 20C18 22.206 19.794 24 22 24H24V25ZM26 21C26 21.551 25.551 22 25 22H22C20.897 22 20 21.103 20 20C20 18.897 20.897 18 22 18H25C25.551 18 26 18.449 26 19V21Z" />
	</svg>
);

export default Wallet;
